import { createFileRoute } from '@tanstack/react-router';

import { ContentEditor } from '../../../@components/content-editor/ContentEditor';
import { treatmentCreateEditorSettings } from '../../../@components/content-editor/treatmentCreateEditorSettings';

export const Route = createFileRoute(
  '/_layout/(private)/my-treatments/$id/new/',
)({
  component: MyTreatmentsNewDetails,
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(
      treatmentCreateEditorSettings.detailsQueryOptions(params.id),
    );
  },
});

function MyTreatmentsNewDetails() {
  const { id } = Route.useParams();

  return <ContentEditor id={id} settings={treatmentCreateEditorSettings} />;
}
